import fetchWithRefresh from './fetchWithRefresh';
import { PATIENT_DIR_V2 } from './constants';
import { PatientDirResponse } from './fetchPatientDirByDocOid';

export default (docIds: string[], pid?: string, from?: string): Promise<PatientDirResponse> =>
    fetchWithRefresh(PATIENT_DIR_V2(docIds, from), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pid }),
    }).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw Error('Error fetching Patient dir');
        }
    });
